import { type UserJwtResponse } from '@on3/api/src';
import { useModal } from '@on3/ui-lib/components/Modal/Provider';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { Barrier } from '@on3/ui-lib/components/Subscription/Templates/Barrier';
import { type PurchaseModalProps } from '@on3/ui-lib/types/purchase';
import { useEffect } from 'react';

import styles from './Protected.module.scss';

export const Protected = () => {
  const {
    isSubscribed,
    templates: { forums },
  } = useSubscribe();

  const { showModal } = useModal();

  const onAuth = (jwt: UserJwtResponse) => {
    window.top?.postMessage({ type: 'USER_LOGIN', jwt }, '*');
  };

  const showAuth = () => {
    showModal('user.auth', {
      callback: (jwt: UserJwtResponse) => {
        onAuth(jwt);

        setTimeout(() => {
          window.top?.postMessage({ type: 'RELOAD' }, '*');
        }, 1000);
      },
    });
  };

  const showJoin = (props: PurchaseModalProps) => {
    showModal('user.join', { ...props, onAuth }, 'screen');
  };

  useEffect(() => {
    document.body.classList.add('blocker-active');

    return () => {
      document.body.classList.remove('blocker-active');
    };
  }, []);

  if (isSubscribed || !forums) {
    return null;
  }

  return (
    <>
      <Barrier
        barrierType="forums"
        handleJoin={showJoin}
        handleLogin={showAuth}
      />
      <div className={styles.blocker} id="blocker" />
    </>
  );
};
